import moment from 'moment';
import { find } from 'lodash';

import { getToday } from 'application/util/time.util';

import './card-with-period.style.sass';
import template from './card-with-period.tpl.pug';

class CardWithPeriodController {
    /* @ngInject */
    constructor($timeout) {
        this.$timeout = $timeout;

        this.periods = [
            {
                name: `This week`,
                isActive: this.isThisWeekActive.bind(this),
                select: this.selectThisWeek.bind(this)
            },
            {
                name: `This month`,
                isActive: this.isUnitActive.bind(this, 'month'),
                select: this.selectUnit.bind(this, 'month')
            },
            {
                name: `This year`,
                isActive: this.isUnitActive.bind(this, 'year'),
                select: this.selectUnit.bind(this, 'year')
            },
            {
                name: `Lifetime`,
                isActive: this.isLifetimeActive.bind(this),
                select: this.selectLifetime.bind(this)
            },
            {
                name: `Custom`,
                isActive: this.isCustomActive.bind(this),
                select: this.showDateRange.bind(this)
            }
        ];
    }

    $onChanges(changeObject) {
        if (changeObject.start || changeObject.end || changeObject.startOfWeek) {
            this.period = find(this.periods, (period) => period.isActive(this.start, this.end));
        }
    }

    isActive(period) {
        return this.period === period;
    }

    isUnitActive(unit, from, to, offset = 0) {
        let { start, end } = this.getUnit(unit, offset);
        return start === from && end === to;
    }

    isThisWeekActive(from, to) {
        return this.isUnitActive('week', from, to, this.startOfWeek);
    }

    isLifetimeActive(from, to) {
        let today = getToday();

        return from === null && to === moment(today).endOf('day').valueOf();
    }

    isCustomActive() {
        return true;
    }

    selectThisWeek() {
        return this.selectUnit('week', this.startOfWeek);
    }

    selectLifetime() {
        let today = getToday();

        return this.onPeriodChange({
            start: null,
            end: moment(today).endOf('day').valueOf()
        });
    }

    selectCustom(start, end) {
        return this.onPeriodChange({
            start,
            end: moment(end).endOf('day').valueOf()
        });
    }

    selectUnit(unit, offset = 0) {
        return this.onPeriodChange(this.getUnit(unit, offset));
    }

    select(period) {
        period.select();
    }

    isConfirmedFilterActive(option) {
        return this.confirmedFilter === option.id;
    }

    selectConfirmedFilter(option) {
        this.confirmedFilter = option.id;
        return this.notifyConfirmedFilterChange();
    }

    showDateRange() {
        if (this.isLifetimeActive(this.start, this.end)) {
            this.selectUnit('month');
        }

        return this.$timeout(this.toggleDateRangeVisibility.bind(this, true), 0);
    }

    hideDateRange() {
        return this.toggleDateRangeVisibility(false);
    }

    toggleDateRangeVisibility(visible) {
        this.isCustomVisible = visible;
    }

    blur(period) {
        if (typeof period.blur === 'function') {
            period.blur();
        }
    }

    getUnit(unit, offset = 0) {
        let today = getToday();

        return {
            start: moment(today).startOf(unit).add(offset, 'day').valueOf(),
            end: moment(today).endOf(unit).add(offset, 'day').valueOf()
        };
    }

    notifyConfirmedFilterChange() {
        if (typeof this.onConfirmedFilterChange === 'function') {
            return this.onConfirmedFilterChange({
                confirmed: this.confirmedFilter
            });
        }
    }
}

export default {
    selector: 'dbADashboardCardWithPeriod',
    template: template(),
    controller: CardWithPeriodController,
    transclude: true,
    bindings: {
        name: '@',
        start: '<',
        end: '<',
        startOfWeek: '<',
        onPeriodChange: '&',
        confirmedFilter: '<?',
        confirmedFilterOptions: '<?',
        onConfirmedFilterChange: '&?'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/card-with-period/card-with-period.cmpt.js